export default __webpack_public_path__ + "static/media/icon-big-share-88-px.063e47b8.svg";